import { render, staticRenderFns } from "./BlogNuevoPost.vue?vue&type=template&id=0c8805b2&scoped=true&"
import script from "./BlogNuevoPost.vue?vue&type=script&lang=js&"
export * from "./BlogNuevoPost.vue?vue&type=script&lang=js&"
import style0 from "./BlogNuevoPost.vue?vue&type=style&index=0&id=0c8805b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8805b2",
  null
  
)

export default component.exports